import { QueryClient, type DefaultOptions } from '@tanstack/react-query';
import { shouldRetry } from './should-retry';

const defaultOptions: DefaultOptions = {
  queries: {
    staleTime: 30_000, // 30s — avoid refetching on every mount
    gcTime: 5 * 60_000, // 5 min
    refetchOnWindowFocus: false,
    retry: shouldRetry,
  },
  mutations: {
    retry: false,
  },
};

export function createQueryClient(): QueryClient {
  return new QueryClient({ defaultOptions });
}
